import React from "react";
import styled from "@emotion/styled";

import { Portfolio } from "@/services/UserService";

import PorfolioCard from "../PorfolioCard";
import { screenLargerThan } from "@/styles";

const StyledItemsContainer = styled.ul`
  ${screenLargerThan.tablet} {
    display: grid;
    gap: 1.5rem;
    grid-template-columns: 1fr 1fr;
    width: 100%;

    & > * {
      margin-top: 3rem;

      &:first-of-type {
        grid-column: 1 / span 2;
      }
    }
  }
`;

const PortfolioDisplay: React.FC<{
  portfolios: Portfolio[];
  className?: string;
}> = ({ portfolios, className }) => {
  return (
    <StyledItemsContainer className={className}>
      {portfolios.map((portfolio, i) => (
        <li key={i}>
          <PorfolioCard portfolio={portfolio} />
        </li>
      ))}
    </StyledItemsContainer>
  );
};

export default PortfolioDisplay;
